import { firstValueFrom } from "rxjs";
import { Actualizador } from "./Actualizador";
import { InvestigacionesService } from "../../../../servicesBackend/investigaciones.service";
import { CuotaDTO, InvestigacionDTO } from "@DTOS";
import { DatosActualizarInvestigacion } from "../DatosActualizarInvestigacion";
import { Cuota } from "@shared/clases";

export class DatosCuotasActualizador extends Actualizador {
    private investigacion: InvestigacionDTO;

    constructor(private investigacionesService: InvestigacionesService) {
        super();
    }

    public async actualizar(
        investigacion: InvestigacionDTO, datos: DatosActualizarInvestigacion
    ): Promise<InvestigacionDTO> {
        this.investigacion = investigacion;
        await Promise.all(datos.datosCuotas!.map(async datosCuotas => {
            if (!datosCuotas.cuotasActivas) {
                return;
            }

            await Promise.all(Object.values(datosCuotas.cuotas).map(async cuota => {
                await this.guardarCuota(cuota);
            }));
        }));
        return investigacion.clon();
    }

    public esActualizador(datos: DatosActualizarInvestigacion): boolean {
        return datos.datosCuotas != null;
    }

    private async guardarCuota(cuota: Cuota) {
        if (this.investigacion == null) {
            return;
        }
        if (cuota.cuotaDTO) {
            cuota.cuotaDTO.cuota = cuota.valor;
            await firstValueFrom(this.investigacionesService.actualizarCuota(this.investigacion, cuota.cuotaDTO));

            return;
        }

        if (cuota.activado && cuota.tag != null) {
            const cuotaDTO = new CuotaDTO({ tag_id: cuota.tag.id, quota: cuota.valor.toString() });
            await firstValueFrom(this.investigacionesService.agregarCuota(this.investigacion, cuotaDTO));
        }
    }
}
